import './sessionblock.less'

import {SessionModel} from 'models/program/SessionModel'
import React from 'react'
import {Mod, style} from 'util/style'
import {
	Programblock,
	ProgramblockContent,
	ProgramblockTime
} from 'views/program/blocks/programblock'
import {ProgramLink} from 'views/program/programlink'

const styles = style('sessionblock')

export const Sessionblock: React.FC<{
	session: SessionModel
	mod?: Mod<'sub' | 'session' | 'sequence' | 'breakout'>
}> = ({session, mod = 'session'}) => {
	const {title, start_time, end_time} = session

	return (
		<div className={styles()}>
			<ProgramLink item={session}>
				<Programblock mod={mod}>
					<ProgramblockTime start_time={start_time} end_time={end_time} />
					<ProgramblockContent title={title} />
				</Programblock>
			</ProgramLink>
		</div>
	)
}
